<script context="module">
</script>

<script>
  import { onDestroy, onMount } from "svelte";
  import Button from "./Button.svelte";
  import {
    createAudioPlayer,
    getGlobalContext,
    getPlayerSingleton,
    resume,
    stopAllExcept,
    USE_WEBAUDIO,
  } from "../util/audio-players.js";
  import PlayButton from "./PlayButton.svelte";
  import { INTERVIEWS } from "../util/constants.js";
  import { get } from "svelte/store";
  import Undo from "../icons/undothick.svelte";

  export let id = null;

  let container = null;
  let isSeeking = false;
  let trackContainer;
  let progress = 0;
  let currentTime = 0;
  let player = getPlayerSingleton(id);

  let state = player.state;

  // console.log("MOUNT", id, [...playerCache.values()]);
  // console.log("CUR", id, player.playing, get(state).playing);

  // player.audio.addEventListener("play", stopOthers);

  const unsub = state.subscribe((curPlayer) => {
    currentTime = curPlayer.currentTime;
    progress = curPlayer.ready
      ? (currentTime / curPlayer.meta.duration) * 100
      : 0;
  });

  onMount(() => {
    if (player) {
      player.load();
      if (container) container.appendChild(player.audio);
    }
    return () => {
      if (container && container.contains && container.contains(player.audio)) {
        if (player.audio.parentElement) {
          player.audio.parentElement.removeChild(player.audio);
        }
      }
    };
  });

  onDestroy(() => {
    // player.audio.removeEventListener("play", stopOthers);
    // if (player) {
    //   // player.stop();
    // }
    unsub();
  });

  // function stopOthers() {
  //   if (player) stopAllExcept(player);
  // }

  function formatTime(sec) {
    const minutes = Math.floor(sec / 60);
    const seconds = Math.floor(sec - minutes * 60);
    return (
      String(minutes).padStart(2, "0") + ":" + String(seconds).padStart(2, "0")
    );
  }

  function seekRelative(sec) {
    if (player) player.seekRelative(sec);
  }

  // = player.state;
  // $: {
  //   unsub();
  //   state = player.state;
  // unsub = state.subscribe((v) => {
  //   progress = player.duration
  //     ? (v.currentTime / player.meta.duration) * 100
  //     : 0;
  // });
  // }
</script>

<div class="audio-player">
  <!-- <div class="audio-component-container" bind:this={container}></div> -->
  <div class="custom-container">
    <div
      class="container"
      class:playing={$state.playing}
      class:ready={$state.ready}
    >
      <div class="toggle-button">
        <PlayButton
          loading={$state.loading}
          playing={$state.playing}
          on:click={async (ev) => {
            ev.preventDefault();
            if (player) {
              // const context = getGlobalContext();
              // context.resume();
              player.trigger();
              player.toggle();
            }
          }}
        />
      </div>
      <div
        class="track"
        bind:this={trackContainer}
        on:pointerdown={async (ev) => {
          const r = ev.currentTarget.getBoundingClientRect();
          const u = (ev.clientX - r.left) / r.width;
          const doSeek = () => player.seek(u, true);

          if (player) {
            ev.preventDefault();
            player.trigger();
            const time = u * player.getDuration();
            isSeeking = true;
            if (!player.playing) {
              doSeek();
              player.play();
            } else {
              doSeek();
            }
          }
        }}
        on:pointerup={(ev) => {}}
      >
        <div class="track-line">
          <div
            class="track-progress"
            style="--progress: {progress.toFixed(4)}%;"
          ></div>
          {#if $state.playing && $state.ready}
            <div
              class="track-thumb"
              style="--progress: {progress.toFixed(4)}%;"
            ></div>
          {/if}
        </div>
      </div>
      <div class="buttons">
        {#each [-15, 30] as dist, i}
          <div class="seek" class:enabled={$state.ready}>
            <button
              disabled={!$state.ready}
              on:click={(ev) => seekRelative(dist)}
            >
              <div class="seek-icon-container" class:rotate={i == 1}>
                <Undo></Undo>
              </div>
              <div class="relative">{Math.abs(dist)}</div>
            </button>
          </div>
        {/each}
        <!-- <Button
      enabled={$state.ready}
      text=">"
      xsmall
      fitHeight
      inline
      on:click={(ev) => seekRelative(30)}
    /> -->
      </div>
      <div class="time">
        <div class="current">{formatTime(currentTime)}</div>
        {#if player && player.meta && player.meta.duration}
          / <div class="total">
            {formatTime(player.meta.duration)}
          </div>{/if}
      </div>
    </div>
  </div>
</div>

<svelte:window
  on:pointerup={(ev) => {
    if (isSeeking) {
      if (player) ev.preventDefault();
      isSeeking = false;
    }
    // const r = ev.target.getBoundingClientRect();
    // const u = (ev.clientX - r.left) / r.width;
    // if (player) {
    //   console.log(u * 100);
    //   player.seek(u, true);
    // }
  }}
  on:pointermove|passive={(ev) => {
    if (isSeeking) {
      const r = trackContainer.getBoundingClientRect();
      const u = (ev.clientX - r.left) / r.width;
      if (player) {
        ev.preventDefault();
        player.seek(u, true);
      }
    }
  }}
/>

<style>
  .audio-player,
  .custom-container,
  .container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    flex-grow: 1;
  }
  .audio-component-container {
    /* display: none; */
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-direction: row;
    margin-top: 20px;
  }
  .container {
    font-size: 12px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    box-sizing: border-box;
    gap: 10px;
    margin-top: 20px;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    /* width: 100%;
    height: 45px;
    position: fixed;
    bottom: 0;
    left: 0;
    background: pink;
    z-index: 100;
    border-top: 1px solid black; */
  }
  .showing {
    border-right: 1px solid black;
  }
  .toggle-button {
    /* border: 1px solid black; */
    /* padding: 10px; */
    /* margin-top: 20px; */
    margin-left: -8px;
    /* margin-right: -8px; */
    height: 32px;
    width: 32px;
    flex-shrink: 0;
    flex-grow: 0;
    overflow: hidden;
    display: flex;
    justify-content: center;
    align-items: center;
    box-sizing: border-box;
  }

  .seek-icon-container {
    display: flex;
    flex-direction: column;
    gap: 0;
  }

  .seek {
    /* padding-left: 10px; */
  }

  .track {
    flex-grow: 1;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 30px;
    cursor: pointer;
    opacity: 0.5;
  }
  .track-line {
    width: 100%;
    background: gray;
    position: relative;
    --track-height: 4px;
    height: var(--track-height);
  }
  .track-progress {
    --progress: 0%;
    position: absolute;
    left: 0;
    top: 0;
    width: var(--progress);
    height: 100%;
    background: black;
  }

  .track-thumb {
    --progress: 0%;
    --thumb-size: 11px;
    position: absolute;
    left: calc(var(--progress) - var(--thumb-size) / 2);
    top: calc(var(--track-height) / 2 - var(--thumb-size) / 2);
    border-radius: 100%;
    width: var(--thumb-size);
    height: var(--thumb-size);
    background: black;
  }

  .buttons {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 15px;
    padding-left: 5px;
    padding-right: 5px;
  }

  .time {
    display: flex;
    gap: 5px;
    font-size: 10px;
    opacity: 0.5;
  }
  .ready .time,
  .ready .track {
    opacity: 1;
  }

  .seek button {
    padding: 0;
    margin: 0;
    appearance: none;
    outline: none;
    background: none;
    border-radius: 0;
    width: 20px;
    /* height: 30px; */
    box-sizing: border-box;
    /* width: auto; */
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    opacity: 0.5;
  }
  .rotate {
    /* rotate: -180deg; */
    transform: scale(-1, 1);
  }
  .seek.enabled button {
    opacity: 1;
  }
  .relative {
    font-size: 9px;
    margin-top: -1px;
  }
  :global(.seek button svg) {
    /* padding: 9px; */
    /* box-sizing: border-box; */
    width: 100%;
    height: auto;
  }
  @media screen and (max-width: 720px) {
    .audio-component-container {
      /* display: flex;
      justify-content: flex-start;
      align-items: center;
      flex-direction: row;
      margin-top: 20px; */
    }
    .custom-container {
      /* display: none; */
    }
    .toggle-button {
      width: 38px;
      height: 38px;
    }
  }
</style>
